import React from 'react'
import Button from './Button'
import TextField from './TextField'

const Form = () => {
    return (
        <form>
            {/* name and email  */}
            <div className="flex items-center space-x-3 mb-6">
                {/* name  */}
                <div className="w-2/4">
                    <TextField htmlFor="name" id="name" type="text" label="Name" />
                </div>
                {/* email  */}
                <div className="w-2/4">
                    <TextField htmlFor="email" id="email" type="email" label="Email"/>
                </div>
            </div>

            {/* phone and subject*/}
            <div className="flex items-center space-x-3 mb-6">
                {/* phone  */}
                <div className="w-2/4">
                    <TextField htmlFor="phone" id="phone" type="number" label="Phone Number" />
                </div>
                {/* subject  */}
                <div className="w-2/4">
                    <TextField htmlFor="subject" id="subject" type="text" label="Subject"/>
                </div>
            </div>

            {/* message  */}
            <div>
                <label htmlFor="message" className="text-sm font-medium text-gray-600 block mb-2">Your Message</label>
                <textarea id="message" className=" focus:ring-4 ring-indigo-300 transition duration-200 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none block w-full p-2" cols="30" rows="10"></textarea>
            </div>

            {/* button  */}
            <div className="mt-3">
                <Button text="🚀 Send Mail" />
            </div>
        </form>
    )
}

export default Form
